import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class GetLastDetailsViewedAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.localStorageRepository
   */
  constructor({localStorageRepository}) {
    super({localStorageRepository})
    this._localStorageRepository = localStorageRepository
  }

  /**
   * @return {Promise<Object, Error>} list of last viewed details ids
   */
  async execute() {
    const lastDetailsViewed = await this._localStorageRepository.getLastDetailsViewed()
    return {lastDetailsViewed}
  }
}
